module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    staticStyle: {
      "padding-left": "50px"
    }
  }, [_c('div', {
    staticClass: "section level2",
    attrs: {
      "id": "the-north-sea"
    }
  }, [_c('div', {
    staticClass: "section level4",
    attrs: {
      "id": "part-1-taybridge-road"
    }
  }, [_c('div', {
    staticClass: "section level5",
    attrs: {
      "id": "aberfeldy-perthshire-scotland"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "section level4",
    attrs: {
      "id": "part-2-lowlands"
    }
  }, [_c('p', {
    staticStyle: {
      "font-family": "calibri",
      "width": "550px",
      "text-align": "center",
      "font-size": "18px",
      "padding-top": "20px"
    }
  }, [_c('em', [_vm._v("Part 2: Lowlands")])]), _vm._v(" "), _c('div', {
    staticClass: "section level5",
    attrs: {
      "id": "groningen-the-netherlands-19301949"
    }
  }, [_c('p', {
    staticStyle: {
      "font-family": "calibri",
      "width": "550px",
      "text-align": "center",
      "font-size": "16px"
    }
  }, [_c('em', [_vm._v("Groningen, the Netherlands, 1930")]), _vm._v("–"), _c('em', [_vm._v("1949")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "width": "550px",
      "font-size": "10pt",
      "font-family": "calibri",
      "padding-top": "20px"
    }
  }, [_vm._v("The afternoon sun was streaming in through the tall window, opening out to a court at the rear of the house. I was in my parents’ bedroom – a small boy sitting on the edge of the brown oak bed. My mother was teaching me to sing the national anthem. She was sitting at the dressing table, brushing her long hair. It was dark blond but in the sunshine, it showed flecks of red. Her clear voice sang:")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "width": "300px",
      "padding-left": "80px",
      "font-size": "10pt",
      "font-family": "calibri"
    }
  }, [_vm._v("“Prince William the Silent, of Dutch descent am I, ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "width": "300px",
      "padding-left": "80px",
      "font-size": "10pt",
      "font-family": "calibri"
    }
  }, [_vm._v(" For my beloved country, I am prepared to die.”")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "width": "550px",
      "font-size": "10pt",
      "font-family": "calibri"
    }
  }, [_vm._v("The house was in the Belle Époque style of the late 19th century. Above the ground floor were two floors with high ceilings and an attic, where the room was that I shared with my younger brother. Through the skylight, I could see the high tower of St Martin’s medieval church. Its bells marked the time, which it measured in lengths of fifteen minutes duration. The carillon would play a longer tune on the hour, a shorter one on the half hour, and would sprinkle just a few notes across the city at the times in between. On feast days, the carillon would sing with all the might of its more than fifty bells, their sound would bounce backwards and forwards between the houses that formed the walls of the streets and squares.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "width": "550px",
      "font-size": "10pt",
      "font-family": "calibri"
    }
  }, [_vm._v("On the ground floor of the house, and extending behind it, was my father’s bakery. The heavy, multi-coloured coat of arms above the door to the shop proudly proclaimed him a supplier to the Queen of the Netherlands. The windows on the first floor of the house overlooked the market square with its 18th-century city hall and its richly embellished Renaissance Gold Office, built in 1635. The square was always busy: there were trams, buses, twice-weekly markets, and regular celebrations. The most important of these was on 28 August, when the city remembered its liberation from the threat of Spanish occupation in 1672. A traditional part of the annual celebration was the stallion inspection on the Market Square. In 1920, Otto Erelman, a resident artist, recorded the event. His painting showed the market from a viewpoint not far from our house. The third person from the left, my father said, was a relative. By the mid-1930s, not much had changed.")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "width": "550px",
      "font-size": "10pt",
      "font-family": "calibri"
    }
  }, [_vm._v("I had three brothers, and later two sisters. As both my parents came from big families, there was a large circle of uncles and aunts. On birthdays, they all gathered. Everybody drank coffee, the men smoked cigars and later drank Geneva gin or wine, the women took small glasses of liqueur. I was more inter- ested in the cake. The men were from all occupations. There were doctors, lawyers, farmers and engineers, and also an oil exploration expert, a minister of the Reformed Church, a grocer, a smith who also shoed mighty big horses")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b9af7708","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Section0018.vue
// module id = 114
// module chunks = 0